// extracted by mini-css-extract-plugin
var _1 = "TestGroupingFormValueItemAnswer_actions__74a09";
var _2 = "TestGroupingFormValueItemAnswer_active__d5e52";
var _3 = "TestGroupingFormValueItemAnswer_floatingHeader__b28d8";
var _4 = "TestGroupingFormValueItemAnswer_header__87278";
var _5 = "TestGroupingFormValueItemAnswer_icon__822db";
var _6 = "TestGroupingFormValueItemAnswer_icons__6f703";
var _7 = "TestGroupingFormValueItemAnswer_img__1a6e7";
var _8 = "TestGroupingFormValueItemAnswer_root__763e1";
var _9 = "TestGroupingFormValueItemAnswer_title__dd3f7";
export { _1 as "actions", _2 as "active", _3 as "floatingHeader", _4 as "header", _5 as "icon", _6 as "icons", _7 as "img", _8 as "root", _9 as "title" }
